module.exports = __webpack_public_path__ + "static/media/lock-opened.00469949.svg";